import './ContainerInputBars.css';

const ContainerInputBars = ({ children }) => <div className="container-password-bars">{children}</div>;

export default ContainerInputBars;
